import { LobbyErrorCode } from "src/app/infrastructure/lobby-proxy/enums/lobby-error-code.enum"


export class LobbyError extends Error {

    constructor(public readonly code: LobbyErrorCode | undefined,
        public readonly category: string | undefined,
        message: string) {
        super(message)

    }
}

export class LobbyErrors extends LobbyError {

    constructor(code: LobbyErrorCode,
        category: string,
        message: string,
        public readonly errors: LobbyError[]) {
        super(code, category, message)
    }
}